export default "__VITE_ASSET__CJPoaqtS__"